import { Component, Input, OnInit } from '@angular/core';
import { MatLegacyDialog as MatDialog } from '@angular/material/legacy-dialog';
import { Router } from '@angular/router';
import { RentalAgreementsDetailsDialogComponent } from '@app/shared/components/rental-agreements-details-dialog/rental-agreements-details-dialog.component';
import { PaginationMeta } from '@app/shared/interfaces';
import { DeviceDetectionService } from '@app/shared/services/device-detection/device-detection.service';
import { BehaviorSubject, Observable, of } from 'rxjs';
import { catchError, finalize, ignoreElements, shareReplay } from 'rxjs/operators';
import { ReservationAgreement, ReservationAgreementService } from '../../../services/reservation-agreements.service';

@Component({
  standalone: false,
  selector: 'sbnb-signed-reservation-agreements',
  templateUrl: './signed-reservation-agreements.component.html',
  styleUrls: ['./signed-reservation-agreements.component.scss'],
})
export class SignedReservationAgreementsComponent implements OnInit {
  // Whether we show signed, or pending agreements
  @Input() signed = false;

  agreements$: Observable<{ data: ReservationAgreement[]; meta: { pagination: PaginationMeta } }>;

  agreementsError$: Observable<boolean>;

  isMobile = false;

  searchCriteria = '';
  currentPage = 1;

  loading$ = new BehaviorSubject<boolean>(false);

  constructor(
    private service: ReservationAgreementService,
    private dialog: MatDialog,
    private deviceDetectionService: DeviceDetectionService,
    private router: Router
  ) {
    this.deviceDetectionService.isMobileViewport().subscribe((isMobile) => {
      this.isMobile = isMobile;
    });
  }

  ngOnInit(): void {
    this.refreshAgreements();

    this.agreementsError$ = this.agreements$.pipe(
      ignoreElements(),
      catchError(() => of(true))
    );
  }

  refreshAgreements() {
    this.loading$.next(true);

    this.agreements$ = this.service.fetchReservationAgreements(this.signed, this.searchCriteria, this.currentPage).pipe(
      finalize(() => this.loading$.next(false)),
      shareReplay(1)
    );
  }

  onClickAgreement(agreement: ReservationAgreement) {
    this.openRentalAgreementDialog(agreement);
  }

  onPageChange(page: number) {
    this.currentPage = page;

    this.refreshAgreements();
  }

  public searchUpdated(searchVal: string) {
    this.currentPage = 1;
    this.searchCriteria = searchVal;

    this.refreshAgreements();
  }

  openRentalAgreementDialog(agreement: ReservationAgreement) {
    const dialog = this.dialog.open(RentalAgreementsDetailsDialogComponent, {
      width: this.isMobile ? '100%' : '720px',
      height: this.isMobile ? '100%' : '80%',
      maxWidth: this.isMobile ? '100vw' : '720px',
      autoFocus: false,
      data: {
        agreement,
        showConversationButton: true,
      },
    });

    dialog.afterClosed().subscribe((result) => {
      if (result?.deleted) {
        this.ngOnInit();
      }
    });
  }
}
